import React, { useState } from 'react';
import styles from './PayOnlineAccordionItems.scss';
import PayOnlineEntryHeader from '../PayOnlineEntryHeader';
import { sortArrayByProperty } from '../../../../modules/sortUtility/sortUtils';

const PayOnlineAccordionItems = ({ renderPayOnlineEntry, stateFacilities }) => {
  const [sortConfig, setSortConfig] = useState(() => ({
    key: 'displayName',
    direction: 'ascending',
  }));

  const onClickSort = (key) => {
    let direction = 'ascending';

    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return (
    <div>
      <PayOnlineEntryHeader onClickSort={onClickSort} sortConfig={sortConfig} showSort />
      {sortArrayByProperty(stateFacilities,
        sortConfig.key, sortConfig.direction).map((facility, index) => (
        <div key={facility.id}>
          {renderPayOnlineEntry(facility)}
          {index < stateFacilities.length && <hr className={styles.divider} />}
        </div>
      ))}
    </div>
  );
};

export default PayOnlineAccordionItems;
